/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TenantCreateDto = {
  /**
   * Tenant name.
   */
  name: string;
  /**
   * Tenant registration number.
   */
  registrationNumber: string;
  /**
   * Contact email of the tenant.
   */
  email: string;
  /**
   * Status of the tenant.
   */
  status: TenantCreateDto.status;
  /**
   * Default locale for tenant users.
   */
  userLocale?: TenantCreateDto.userLocale;
  /**
   * Default locale for tenant clients.
   */
  clientLocale?: TenantCreateDto.clientLocale;
};
export namespace TenantCreateDto {
  /**
   * Status of the tenant.
   */
  export enum status {
    ACTIVE = 'ACTIVE',
    SUSPENDED = 'SUSPENDED',
    DEACTIVATED = 'DEACTIVATED',
  }
  /**
   * Default locale for tenant users.
   */
  export enum userLocale {
    EN = 'EN',
    LV = 'LV',
    NO = 'NO',
    FI = 'FI',
  }
  /**
   * Default locale for tenant clients.
   */
  export enum clientLocale {
    EN = 'EN',
    LV = 'LV',
    NO = 'NO',
    FI = 'FI',
  }
}

